<template>
  <a-modal
    title="绑定追溯模板"
    width="80%"
    :visible="visible"
    :maskStyle="{'top':'93px','left':'154px'}"
    :maskClosable="false"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="取消"
    okText="保存"
    style="top:5%;height: 90%;">
    <traceList ref="traceList" @update:selectRows="getSelectRows"></traceList>
  </a-modal>
</template>

<script>
import traceList from '../traceList.vue'
import { traceRule } from '@api/api'
export default {
  name: "traceListModel",
  components: {
    traceList
  },
  data () {
    return {
      visible: false,
      item:{},
      ruleId: null,
      selectedRowKeys:[],
    }
  },
  methods:{
    open(item){
      this.item = item
      this.ruleId = item.uuid
      console.log(this.item,'this.item都有什么')
      this.visible = true
      
    },
    handleCancel(){
      this.visible = false
    },
    getSelectRows(selectedRowKeys){
      this.selectedRowKeys = selectedRowKeys
      console.log(selectedRowKeys,'selectedRowKeys============')
    },
    handleOk(){
      console.log(this.selectedRowKeys,'selectedRowKeys============')
      if( this.selectedRowKeys.length == 0 ){
        this.$message.error('请选择1个页面模板')
      }else{
        traceRule({
          ruleId: this.ruleId,
          templateId: this.selectedRowKeys[0]
        }).then((res)=>{
          if( res.code == 200 && res.success == true ){
            this.$message.success('绑定成功')
            this.visible = false
          } else {
            this.$message.error('绑定失败')
          }
        });
      }
    }
  }
}

</script>

<style scoped>

</style>